import { Spacings, Radius, FontSizes, LineHeights } from '@picsart/ds-foundation';

const ControlSizesXL = {
    height: 48,
    paddingHorizontal: Spacings.s16,
    paddingVertical: Spacings.s12,
    padding: Spacings.s16,
    borderRadius: Radius.r8,
    gap: Spacings.s8,
    fontSize: FontSizes.s16,
    lineHeight: LineHeights.l24,
    iconSize: 24,
};
const ControlSizesLG = {
    height: 44,
    paddingHorizontal: Spacings.s16,
    paddingVertical: Spacings.s10,
    padding: Spacings.s12,
    borderRadius: Radius.r8,
    gap: Spacings.s8,
    fontSize: FontSizes.s16,
    lineHeight: LineHeights.l24,
    iconSize: 24,
};
const ControlSizesMD = {
    height: 40,
    paddingHorizontal: Spacings.s12,
    paddingVertical: Spacings.s10,
    padding: Spacings.s12,
    borderRadius: Radius.r8,
    gap: Spacings.s8,
    fontSize: FontSizes.s14,
    lineHeight: LineHeights.l20,
    iconSize: 20,
};
const ControlSizesSM = {
    height: 32,
    paddingHorizontal: Spacings.s12,
    paddingVertical: Spacings.s6,
    padding: Spacings.s8,
    borderRadius: Radius.r8,
    gap: Spacings.s4,
    fontSize: FontSizes.s14,
    lineHeight: LineHeights.l20,
    iconSize: 20,
};

export { ControlSizesLG, ControlSizesMD, ControlSizesSM, ControlSizesXL };
